import * as Long from "long";
import { combineEpics, ofType } from "redux-observable";
import { EMPTY, from } from "rxjs";
import { switchMap } from "rxjs/operators";
import { selectXpInfo } from "../../selectors/selectXpInfo";
import { actionInventoryInfoAddResource } from "../info/inventory/actionInventoryInfo";
import { actionPlayerInfoAddLevel, TypeActionPlayerInfo, } from "../info/player/actionPlayerInfo";
import { actionQuestInfoRequest } from "../info/quest/actionQuestInfo";
import { actionModalCloseAll, actionModalOpen } from "../modals/actionModal";
import { IdModal } from "../modals/IdModal";
var epicXpLevelUp = function (action$, state$) {
    return action$.pipe(ofType(TypeActionPlayerInfo.AddXp), switchMap(function (action) {
        var state = state$.value;
        var info = selectXpInfo(state);
        if (info.nextLevel === undefined) {
            return EMPTY;
        }
        var rewards = info.nextLevel.reward
            ? info.nextLevel.reward.map(function (reward) { return ({
                amount: Long.fromInt(reward.amount),
                typeId: reward.resourceId,
            }); })
            : [];
        var xpDiff = Long.fromValue(info.nextLevel.requiredXp).subtract(info.xp);
        if (xpDiff.lessThanOrEqual(0)) {
            return from([
                actionPlayerInfoAddLevel(1),
                actionQuestInfoRequest(),
                actionInventoryInfoAddResource(rewards),
                actionModalCloseAll(),
                actionModalOpen(IdModal.LevelUp),
            ]);
        }
        return EMPTY;
    }));
};
export var epicXp = combineEpics(epicXpLevelUp);



//////////////////
// WEBPACK FOOTER
// ./src/features/xp/epicXp.ts
// module id = 2511
// module chunks = 3